import React from "react";

export const InstalmentIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 7.75V4.75" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M3.75 13.25H20.25" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M3.75 8.25H20.25" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M3.75 18.25H20.25" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M8.5 5.25H15.5" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
	</svg>
);

export const OneTimeIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 11L11 13L15.5 8.5" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V6.75C19.25 5.64543 18.3546 4.75 17.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75Z" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const PayAsYouUseIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M17.25 8C17.25 8 16 4.75 12 4.75C8 4.75 6.75 8 6.75 8" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6.75 16C6.75 16 8 19.25 12 19.25C16 19.25 17.25 16 17.25 16" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M19.25 12H4.75" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M12 4.75V2.75" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M12 21.25V19.25" stroke="var(--app-primary-text-09)" strokeWidth="1.25" strokeLinecap="round" />
	</svg>
);

export const ChevronRightIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 6L15 12L9 18" stroke="var(--app-primary-text-05)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
